export interface ICivicAddress {
    CivicId?: number | null;
    Apartment?: string | null;
    CivicNum: string;
    StreetName: string;
    StreetType: string;
    City: string;
    Municipality: string;
    County: string;
    LotNum: string;
    PID: string;
}

export class CivicAddress implements ICivicAddress {
    public CivicId = null;
    public Apartment = null;
    public CivicNum = '';
    public StreetName = '';
    public StreetType = '';
    public City = '';
    public Municipality = '';
    public County = '';
    public LotNum = '';
    public PID = '';
    constructor(
        civObject: any,
    ) {
        this.CivicId = civObject.civicId;
        this.Apartment = civObject.apartment;
        this.CivicNum = civObject.civicNum;
        this.StreetName = civObject.streetName;
        this.StreetType = civObject.streetType;
        this.City = civObject.city;
        this.Municipality = civObject.municipality;
        this.County = civObject.county;
        this.LotNum = civObject.lotNum;
        this.PID = civObject.pid;
    }
}



